import { gql } from '@apollo/client';
import { PartnerContactInfo } from '../fragments';

export default gql`
  query partnerContacts($partnerOrganizationId: ID, $partnerLocationId: ID) {
    partnerContacts(partnerOrganizationId: $partnerOrganizationId, partnerLocationId: $partnerLocationId) {
      ...PartnerContactInfo
    }
  }
  ${PartnerContactInfo}
`;
